import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'

type EmptySearchResultProps = {
  containerClassName?: string
}

const EmptySearchResult: React.FC<EmptySearchResultProps> = ({
  containerClassName = '',
}) => (
  <Container className={containerClassName}>
    <Row noGutters>
      <Col xs={12} className="flex-center">
        <img
          src="/images/empty-chair.svg"
          srcSet="/images/empty-chair.webp"
          alt="No Results Available"
          width="350"
          height="220"
        />
      </Col>
      <Col className="text-center py-5">
        <span className="fs-18 pt-3 font-weight-bold">
          Sorry, we don&#39;t have any available providers who match your
          criteria.
        </span>
        <div className="pt-1">
          Schedules change daily &ndash; try adjusting your filters or check
          back soon.
        </div>
      </Col>
    </Row>
  </Container>
)

export default EmptySearchResult
